<div class="row">
  <div class="col-md-12">
    <div class="align-items-center field-summary border-top border-bottom">
      <div class="pe-3 me-3">
        <label class="header-value">
          <strong>Field Name:</strong>
        </label>
        <span class="field-value">
          {{ fieldname }}
        </span>
      </div>
    </div>
  </div>
</div>
<div class="d-flex align-items-center justify-content-center">
  <div class="loading" *ngIf="loading"></div>
</div>
<div *ngIf="!loading">
  <div class="container" *ngIf="form">
    <div class="row pt-4">
      <div class="col-md-6 ms-2">
        <wre-toolkit-text-field class="w-100" labelText="Value Name" (keypress)="onKeypressEvent($event)" inputId="newValue"
          [control]="form.get('newValue')">
        </wre-toolkit-text-field>
      </div>
      <div class="col-md-2 pt-4 mt-2">
        <wre-toolkit-toggle-switch [control]="form.get('isActive')" (change)="getToggleValue()" inputId="isActive" labelText="{{toggleBtnVal ? 'Active': 'Inactive'}}">
        </wre-toolkit-toggle-switch>
      </div>
      <div class="col-md-2 pt-4 mt-2">
        <button type="button" class="btn wre-btn btn-secondary" (click)="add()">
          Add Value
        </button>
      </div>
    </div>
    <div class="row" *ngIf="duplicate">
      <div class="col-md-8 wre-form-error pt-2">
        A value already exists with this name. Values must be unique.
      </div>
    </div>
    <div class="row" *ngIf="invalid">
      <div class="col-md-8 wre-form-error pt-2">
        Value must be valid.
      </div>
    </div>
    <div class="user-grid border-top">
      <wre-field-options-table [control]="form.get('options')"></wre-field-options-table>
    </div>
  </div>
</div>